import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getAPIConfig } from '@tcp/core/src/utils';
import StyledPixleeReviewWidget from '../styles/PixleeReviewWidget.style';

const PixleeReviewWidget = ({ productSKU, isPDPRedesignEnabled, isStyleColorRnREnabled }) => {
  const { PIXLEE_SITE_KEY, locale = 'en_US' } = getAPIConfig();

  useEffect(() => {
    if (productSKU) {
      const initializePixleeConfig = () => {
        window.turnToConfig = {
          locale,
          pageId: 'pdp-page',
          sku: isStyleColorRnREnabled ? productSKU : productSKU?.split('_')[0],
        };
        window.TurnToCmd =
          window.TurnToCmd ||
          // eslint-disable-next-line func-names
          function () {
            // eslint-disable-next-line prefer-rest-params
            (window.TurnToCmd.q = window.TurnToCmd.q || []).push(arguments);
          };
      };
      if (window.turnToConfig) {
        window.TurnToCmd('set', {
          sku: isStyleColorRnREnabled ? productSKU : productSKU?.split('_')[0],
        });
        initializePixleeConfig();
        window.TurnToCmd('initialize', 'reviews-summary');
        window.TurnToCmd('initialize', 'reviews-list');
      } else {
        initializePixleeConfig();
        const script = document.createElement('script');
        script.src = `https://widgets.turnto.com/v5/widgets/${PIXLEE_SITE_KEY}/js/turnto.js`;
        script.async = true;
        document.body.appendChild(script);

        const popoverStyle = document.createElement('style');
        popoverStyle.textContent = `
          .tt-o-popover--success {
            background-color: #fff !important;
          }
          .tt-o-popover--success p.tt-o-popover__text {
            color: #008477 !important;
          }
          .tt-o-popover--success .tt-o-icon {
            fill: #008477 !important;
          }
          .tt-o-button--tertiary:hover .tt-o-icon, button.tt-o-button--tertiary:hover .tt-o-icon {
            fill: #fff !important;
          }
          .tt-o-button--tertiary:hover,button.tt-o-button--tertiary:hover {
            color: #fff !important;
          }
        `;
        document.head.appendChild(popoverStyle);
      }
    }
  }, [productSKU]);

  return (
    <StyledPixleeReviewWidget isPDPRedesignEnabled={isPDPRedesignEnabled}>
      <div id="tt-reviews-summary" />
      <div id="tt-reviews-list" />
    </StyledPixleeReviewWidget>
  );
};

export default PixleeReviewWidget;

PixleeReviewWidget.propTypes = {
  productSKU: PropTypes.string.isRequired,
};
